// 目前@babel/plugin-transform-runtime不支持类似@babel/preset-env的exclude配置，导致promise的polyfill被打入，而这里sdk本身对promise没有依赖，不应该被打入，借助.babelrc跳过
// 相关issue：https://github.com/babel/babel/pull/11572
export function isPromise(r) {
  // 小程序环境有Promise，但不在window下
  return typeof Promise !== 'undefined' && r instanceof Promise;
}